import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-form-verification-condition-suspensive-test",
  templateUrl: "./form-verification-condition-suspensive-test.component.html",
  styleUrls: ["./form-verification-condition-suspensive-test.component.scss"],
})
export class FormVerificationConditionSuspensiveTestComponent
  implements OnInit
{
  constructor() {}

  ngOnInit() {}
}
